const blockStructure = {
  I : [
    [1,1,1,1]
  ],
  L : [
    [1,0,0],
    [1,1,1]
  ],
  J : [
    [0,0,1],
    [1,1,1]
  ],
  Z : [
    [1,1,0],
    [0,1,1]
  ],
  S : [
    [0,1,1],
    [1,1,0]
  ],
  O : [
    [1,1],
    [1,1]
  ],
  T : [
    [0,1,0],
    [1,1,1]
  ]
};

const blocks = ['I','L','J','Z','S','O','T'];

export { blockStructure, blocks };
